import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";
import {
  useGetPaymentAccountDetailQuery,
  useUpdatePaymentAccountMutation,
} from "store/services/PaymentsApi/paymentAccountApi";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import PaymentAccountForm from "./paymentAccountComponents/PaymentAccountForm";

const breadcrumbs = [
  { title: "Payment Account", path: "/app/crm/payment-account/list" },
  { title: "Edit Payment Account" },
];
const PaymentAccountEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const { data: paymentAccountDetail, isLoading: paymentAccountLoading } =
    useGetPaymentAccountDetailQuery(id);

  // RTK Query
  const [updatePaymentAccount, { isLoading: updatingPaymentAccount }] =
    useUpdatePaymentAccountMutation();

  // methods
  const handlePaymentAccountUpdate = async (data) => {
    try {
      await updatePaymentAccount(data).unwrap();
      navigate(`/app/crm/payment-account/${id}/detail`);
      toast.success("PaymentAccount successfully updated!");
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update PaymentAccount!");
    }
  };

  useAppMeta("Edit Payment Account");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={paymentAccountLoading || updatingPaymentAccount}
    >
      <BreadcrumbLayout.Paper>
        <PaymentAccountForm
          paymentAccountDetail={paymentAccountDetail}
          isBusy={paymentAccountLoading}
          onSubmit={handlePaymentAccountUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default PaymentAccountEditScreen;
